import React, { useState } from 'react';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const DebugLogin = () => {
  const { login, user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: 'admin@test.com',
    password: 'password123'
  });
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDirectApiLogin = async () => {
    setLoading(true);
    setResult(null);
    
    try {
      console.log('Direct API test - Attempting login with:', credentials);
      const response = await authAPI.login(credentials);
      console.log('Direct API test - Login response:', response);
      setResult({ success: true, data: response, type: 'direct' });
    } catch (error) {
      console.error('Direct API test - Login error:', error);
      setResult({ 
        success: false, 
        error: error?.response?.data?.detail || error.message,
        type: 'direct'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAuthContextLogin = async () => {
    setLoading(true);
    setResult(null);
    
    try {
      console.log('AuthContext test - Attempting login with:', credentials);
      const response = await login(credentials);
      console.log('AuthContext test - Login response:', response);
      setResult({ success: response.success, data: response, type: 'context' });
      
      // If login successful, wait a moment then redirect to home to test persistence
      if (response.success) {
        setTimeout(() => {
          console.log('Redirecting to home page to test auth persistence...');
          navigate('/');
        }, 2000);
      }
    } catch (error) {
      console.error('AuthContext test - Login error:', error);
      setResult({ 
        success: false, 
        error: error?.message || 'Unknown error',
        type: 'context'  
      });
    } finally {
      setLoading(false);
    }
  };

  const checkLocalStorage = async () => {
    const token = localStorage.getItem('auth_token');
    const userData = localStorage.getItem('user_data');
    
    setResult({
      success: true,
      data: {
        token: token ? token.substring(0, 30) + '...' : 'No token found',
        userData: userData ? JSON.parse(userData) : 'No user data found'
      },
      type: 'localStorage'
    });
  };

  return (
    <div className="p-8 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Debug Login Tests</h1>
      
      {/* Current Auth State */}
      <div className="mb-6 p-4 bg-gray-100 rounded">
        <h3 className="font-bold">Current Auth State:</h3>
        <p>Authenticated: <span className={isAuthenticated ? 'text-green-600' : 'text-red-600'}>{isAuthenticated ? 'Yes' : 'No'}</span></p>
        <p>User: {user?.full_name || 'None'}</p>
        <p>User ID: {user?.id || 'None'}</p>
        <p>Email: {user?.email || 'None'}</p>
      </div>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Email:</label>
          <input
            type="email"
            value={credentials.email}
            onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
            className="w-full border rounded px-3 py-2"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Password:</label>
          <input
            type="password"
            value={credentials.password}
            onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
            className="w-full border rounded px-3 py-2"
          />
        </div>
        
        <div className="flex gap-4 flex-wrap">
          <button
            onClick={handleDirectApiLogin}
            disabled={loading}
            className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
          >
            {loading ? 'Testing...' : 'Test Direct API'}
          </button>
          
          <button
            onClick={handleAuthContextLogin}
            disabled={loading}
            className="bg-green-500 text-white px-4 py-2 rounded disabled:opacity-50"
          >
            {loading ? 'Testing...' : 'Test AuthContext'}
          </button>
          
          <button
            onClick={checkLocalStorage}
            className="bg-purple-500 text-white px-4 py-2 rounded"
          >
            Check localStorage
          </button>
          
          <button
            onClick={() => navigate('/')}
            className="bg-gray-500 text-white px-4 py-2 rounded"
          >
            Go to Homepage
          </button>
        </div>
        
        {result && (
          <div className={`p-4 rounded ${result.success ? 'bg-green-100' : 'bg-red-100'}`}>
            <h3 className="font-bold">
              {result.type === 'direct' ? 'Direct API' : result.type === 'context' ? 'AuthContext' : 'LocalStorage'} Test Result: 
              {result.success ? ' SUCCESS' : ' FAILED'}
            </h3>
            <pre className="text-sm mt-2 overflow-auto whitespace-pre-wrap max-h-96">
              {JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default DebugLogin;